import { gql } from '@apollo/client';

export const PATCH_OBJECTIVE_MUTATION = gql`
    mutation patchObjective($input: PatchObjectiveInput!) {
        result: patchObjective(input: $input) {
            id
            locales {
                code,
                name,
                description
            }
            createdAt
            updatedAt
            availableAt
            isPublished
            isRepeatable
            points
            badgeId
            credits
            publishAt
            revisionId
            unavailableAt
            maxEngagements
            weight
            criteria {
                id            
                targetCount
                targetValue
                weight
                isEnabled
                criterionType {
                    id
                }
            }
        }
    } 
`;
